export default {
	"home":"Zuhause",
	"homeOne":"Zuhause eins",
	"homeTwo":"Zuhause zwei",
	"homeThree":"Zuhause drei",
	"userProfile":"Benutzerprofil",
	"shop":"Geschäft",
	"productDetails": "Produktdetails",
	"cart": "Wagen",
	"checkout":"Auschecken",
	"payment":"Zahlung",
	"fashion":"Mode",
	"gadgets":"Gadgets",
	"accessories":"Zubehör",
	"categories":"Kategorien",
	"men":"Männer",
	"jean":"Jean",
	"jackets":"Jacken",
	"shirt":"Hemd",
	"tShirt":"T-Shirt",
	"women":"Frau",
	"dress":"Kleid",
	"dresses":"Kleider",
	"headphone":"Kopfhörer",
	"smartphone":"Smartphone",
	"watch":"Sehen",
	"speaker":"Redner",
	"laptopAccessories":"Laptop-Zubehör",
	"belts":"Gürtel",
	"jewellery":"Schmuck",
	"purse":"Geldbörse",
	"pages":"Seiten",
	"about":"Über",
	"termAndCondition":"Nutzungsbedingungen",
	"privacyPolicy":"Datenschutz-Bestimmungen",
	"blogDetail":"Blog-Detail",
	"faq":"FAQ",
	"Page":"Seite",
	"404Page":'404 Seite',
	"session":"Session",
	"signIn":"Einloggen",
	"register":"Registrieren",
	"forgotPassword":"Passwort vergessen",
	"thankYou":"Danke dir",
	"contactUs":"Kontaktiere uns",
	"social":"Sozial",
	"facebook":"Facebook",
	"twitter":"Twitter",
	"youtube":"Youtube",
	"googlePlus":"Google Plus",
	"reports":"Berichte",
	"invoices":"Rechnungen",
	"profile":"Profil",
	"products":"Produkte",
	"productAdd":"Produkt hinzufügen",
	"goToSite":"Gehe zur Site",
	"adminPanel":"Administrationsmenü",
	"edit":"bearbeiten"
}